import backgroundImg from '../new-delivery-result-card/background.png';
import buttonAgainImg from '../new-delivery-result-card/button_again.png';
import buttonMoreDetailsImg from '../new-delivery-result-card/button_more_details.png';
import closedItemFrameImg from './delivery_closed_item_frame.png';
import decorLabelSvg from './decor_label.svg';
import giantNameTextSvg from './giant_name_text.svg';
import levelNameTextSvg from './level_name_text.svg';

export const DELIVERY_CARD_BACKGROUND_URL = backgroundImg;
export const DELIVERY_CARD_BUTTON_AGAIN_URL = buttonAgainImg;
export const DELIVERY_CARD_BUTTON_MORE_DETAILS_URL = buttonMoreDetailsImg;
export const DELIVERY_CARD_CLOSED_FRAME_URL = closedItemFrameImg;
export const DELIVERY_CARD_DECOR_LABEL_URL = decorLabelSvg;
export const DELIVERY_CARD_GIANT_NAME_TEXT_URL = giantNameTextSvg;
export const DELIVERY_CARD_LEVEL_NAME_TEXT_URL = levelNameTextSvg;

export const DELIVERY_CARD_ASSET_URLS = [
  DELIVERY_CARD_BACKGROUND_URL,
  DELIVERY_CARD_BUTTON_AGAIN_URL,
  DELIVERY_CARD_BUTTON_MORE_DETAILS_URL,
  DELIVERY_CARD_CLOSED_FRAME_URL,
  DELIVERY_CARD_DECOR_LABEL_URL,
  DELIVERY_CARD_GIANT_NAME_TEXT_URL,
  DELIVERY_CARD_LEVEL_NAME_TEXT_URL,
] as const;
